export enum ConfigLoadEnum
{
  Company = 'Company',
  Craft = 'Craft',
  Order = 'Order',
  Contact = 'Contact',
  Classification = 'Classification' ,
  UserDefined = 'UserDefined',
  DocumentType = 'DocumentType',
  Attribute = 'Attribute',


}
